import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { FiMenu } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import Logo from "../../assets/logo.svg";

const services = [
  { id: "graphic-design", name: "Graphic Design" },
  { id: "bookkeeping", name: "Bookkeeping" },
  { id: "video-editing", name: "Video Editing" },
  { id: "web-development", name: "Web Development" },
  { id: "ui-ux-design", name: "UI/UX Design" },
  { id: "digital-marketing", name: "Digital Marketing" },
];

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [activeSection, setActiveSection] = useState("home");

  const handleNavClick = (path) => {
    if (path === "about" || path === "courses") {
      navigate(`/${path}`);
    } else {
      setActiveSection(path);
      if (!isHomePage) {
        navigate("/");
        setTimeout(() => {
          scroller.scrollTo(path, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -50,
          });
        }, 500);
      } else {
        scroller.scrollTo(path, {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -50,
        });
      }
    }
  };

  useEffect(() => {
    if (!isHomePage) setActiveSection("");
  }, [location]);

  return (
    <div className="relative z-20 mx-auto w-full max-w-7xl bg-white/60 px-4 py-3.5 backdrop-blur-md sm:px-6 md:px-8 lg:px-8 xl:w-[80%] xl:rounded-full xl:border xl:border-[#d4d4d491] xl:shadow-lg">
      <nav className="navbar relative z-50 flex items-center justify-between">
        <a onClick={() => handleNavClick("home")} className="cursor-pointer">
          <img src={Logo} alt="logo" className="w-[100px] sm:w-[140px]" />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden gap-x-8 lg:flex">
          <a
            onClick={() => handleNavClick("home")}
            className={`cursor-pointer hover:text-orange-500 ${activeSection === "home" ? "text-orange-500" : ""}`}
          >
            Home
          </a>
          <a
            onClick={() => handleNavClick("about")}
            className={`cursor-pointer hover:text-orange-500 ${location.pathname === "/about" ? "text-orange-500" : ""}`}
          >
            About
          </a>

          <Popover className="relative">
            {({ close }) => (
              <>
                <PopoverButton
                  className={`flex items-center outline-none hover:text-orange-500 ${location.pathname.startsWith("/service-details") ? "text-orange-500" : ""}`}
                >
                  Services
                  <FaChevronDown className="ml-2 text-sm transition duration-300" />
                </PopoverButton>
                <PopoverPanel className="absolute left-0 mt-8 w-64 overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="py-2">
                    {services.map((service) => (
                      <button
                        key={service.id}
                        onClick={() => {
                          navigate(`/service-details/${service.id}`);
                          close();
                        }}
                        className={`block w-full px-4 py-2 text-left text-sm hover:bg-blue-100/30 ${location.pathname.endsWith(service.id) ? "text-orange-500" : "text-gray-700"}`}
                      >
                        {service.name}
                      </button>
                    ))}
                  </div>
                </PopoverPanel>
              </>
            )}
          </Popover>

          <a
            onClick={() => handleNavClick("testimonial")}
            className={`cursor-pointer hover:text-orange-500 ${activeSection === "testimonial" ? "text-orange-500" : ""}`}
          >
            Testimonial
          </a>

          <a
            onClick={() => handleNavClick("teams")}
            className={`cursor-pointer hover:text-orange-500 ${activeSection === "teams" ? "text-orange-500" : ""}`}
          >
            Teams
          </a>

          <a
            onClick={() => handleNavClick("courses")}
            className={`cursor-pointer hover:text-orange-500 ${location.pathname === "/courses" ? "text-orange-500" : ""}`}
          >
            Courses
          </a>
        </div>

        <div className="flex items-center">
          <a
            href="/contact"
            className="fontSuse mr-2 rounded-full bg-custom-black px-3 py-2 text-sm uppercase text-white hover:bg-custom-dark-blue sm:mr-4 sm:px-6"
          >
            GET IN TOUCH
          </a>
          <div className="lg:hidden">
            <MobileNavigation />
          </div>
        </div>
      </nav>
    </div>
  );
}

function MobileNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [activeSection, setActiveSection] = useState("home");

  const handleNavClick = (path) => {
    if (path === "about" || path === "courses") {
      navigate(`/${path}`);
    } else {
      setActiveSection(path);
      if (!isHomePage) {
        navigate("/");
        setTimeout(() => {
          scroller.scrollTo(path, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -50,
          });
        }, 500);
      } else {
        scroller.scrollTo(path, {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -50,
        });
      }
    }
  };

  useEffect(() => {
    if (!isHomePage) setActiveSection("");
  }, [location]);

  return (
    <Popover>
      {({ close }) => (
        <>
          <PopoverButton className="flex h-8 w-8 items-center justify-center focus:outline-none">
            <FiMenu className="h-6 w-6" />
          </PopoverButton>
          <PopoverPanel className="absolute inset-x-0 top-full mt-6 flex origin-top flex-col rounded-2xl bg-white py-4 text-lg shadow-xl ring-1 ring-slate-900/5">
            <a
              onClick={() => {
                handleNavClick("home");
                close();
              }}
              className={`block px-4 py-2 hover:bg-blue-100/30 ${activeSection === "home" ? "text-orange-500" : ""}`}
            >
              Home
            </a>
            <a
              onClick={() => {
                handleNavClick("about");
                close();
              }}
              className={`block px-4 py-2 hover:bg-blue-100/30 ${location.pathname === "/about" ? "text-orange-500" : ""}`}
            >
              About
            </a>

            <Disclosure>
              {({ open }) => (
                <>
                  <DisclosureButton className="flex w-full items-center px-4 py-2 hover:bg-blue-100/30">
                    <span
                      className={`${location.pathname.startsWith("/service-details") ? "text-orange-500" : ""}`}
                    >
                      Services
                    </span>
                    <FaChevronDown
                      className={`ml-2 text-sm transition ${open ? "rotate-180" : ""}`}
                    />
                  </DisclosureButton>
                  <DisclosurePanel className="px-4 py-2">
                    {services.map((service) => (
                      <button
                        key={service.id}
                        onClick={() => {
                          navigate(`/service-details/${service.id}`);
                          close();
                        }}
                        className={`block w-full px-4 py-2 text-left text-sm ${location.pathname.endsWith(service.id) ? "text-orange-500" : "text-gray-700"}`}
                      >
                        {service.name}
                      </button>
                    ))}
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>

            <a
              onClick={() => {
                handleNavClick("testimonial");
                close();
              }}
              className={`block px-4 py-2 hover:bg-blue-100/30 ${activeSection === "testimonial" ? "text-orange-500" : ""}`}
            >
              Testimonial
            </a>
            <a
              onClick={() => {
                handleNavClick("teams");
                close();
              }}
              className={`block px-4 py-2 hover:bg-blue-100/30 ${activeSection === "teams" ? "text-orange-500" : ""}`}
            >
              Teams
            </a>
            <a
              onClick={() => {
                handleNavClick("courses");
                close();
              }}
              className={`block px-4 py-2 hover:bg-blue-100/30 ${location.pathname === "/courses" ? "text-orange-500" : ""}`}
            >
              Courses
            </a>
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
}

export default Navbar;
